import React, { forwardRef } from 'react';

import { SwitchProps } from './types';

import { Switch as DefaultSwitch, SwitchWrapper } from './styled';

const Switch = forwardRef<HTMLElement, SwitchProps>(({ children, ...props }, ref) => {
  return (
    <SwitchWrapper size={props.size}>
      <DefaultSwitch ref={ref} {...props} />
      {children}
    </SwitchWrapper>
  );
});

export default Switch;
